<template>
  <div class="px-4 py-3 d-flex flex-column">
    <span style="font-weight: bold;color:#262626" class="mb-2"
    v-if="nombreRuta !== 'oferta-empleo'">Filtros</span>
    <!-- Fecha de publicación -->
    <div v-if="nombreRuta === 'oferta-empleo'" class="mt-4">
      <div class="filtro-label mb-1">Fecha de publicación</div>
      <v-menu
        ref="menuFecha"
        v-model="menuFecha"
        :close-on-content-click="false"
        transition="scale-transition"
        nudge-bottom="40"
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            class="rounded-xl"
            v-model="fechaPublicacionFormatted"
            placeholder="DD-MM-AAAA / DD-MM-AAAA"
            prepend-inner-icon="mdi-calendar"
            readonly
            outlined
            dense
            hide-details
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="fechasPublicacion"
          no-title
          range
          color="primary"
          locale="es"
        ></v-date-picker>
      </v-menu>
    </div>

    <!-- Fecha de postulación -->
    <div
      v-if="nombreRuta === 'mi-postulaciones'"
      class="filtro-label mt-4 mb-1"
    >
      Fecha de postulación
      <v-menu
        ref="menuPostulacion"
        v-model="menuPostulacion"
        :close-on-content-click="false"
        transition="scale-transition"
        nudge-bottom="40"
        max-width="290px"
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            class="rounded-xl"
            v-model="fechaPostulacionFormatted"
            placeholder="DD-MM-AAAA / DD-MM-AAAA"
            prepend-inner-icon="mdi-calendar"
            readonly
            outlined
            dense
            hide-details
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="fechasPostulacion"
          no-title
          range
          color="primary"
          locale="es"
        ></v-date-picker>
      </v-menu>
    </div>
    <!-- Institución -->
    <div class="filtro-label mt-4 mb-1">Institución</div>
    <v-select
      class="rounded-xl"
      v-model="localFiltro.institucion"
      :items="instituciones"
      item-text="nombre"
      item-value="id"
      placeholder="Seleccione"
      outlined
      dense
      clearable
      hide-details
      :menu-props="{ bottom: true, offsetY: true }"
    ></v-select>

    <!-- Establecimiento -->
    <div class="filtro-label mt-4 mb-1">Establecimiento</div>
    <v-select
      class="rounded-xl"
      v-model="localFiltro.establecimiento"
      :items="establecimientos"
      item-text="nombre"
      item-value="id"
      placeholder="Seleccione"
      outlined
      dense
      clearable
      hide-details
      :menu-props="{ bottom: true, offsetY: true }"
    ></v-select>

    <!-- Área de interés -->
    <div class="filtro-label mt-4 mb-1">Área de interés</div>
    <v-autocomplete
      class="rounded-xl"
      v-model="localFiltro.area_interes"
      :items="areasInteres"
      item-text="nombre"
      item-value="id"
      placeholder="Seleccione"
      outlined
      dense
      clearable
      hide-details
      :menu-props="{ bottom: true, offsetY: true }"
    ></v-autocomplete>
    <!-- Estado de postulación -->
    <div
      v-if="nombreRuta === 'mi-postulaciones'"
      class="filtro-label mt-4 mb-1"
    >
      Estado de postulación
      <v-select
        class="rounded-xl"
        v-model="localFiltro.estado_postulacion"
        :items="estadoPostulacion"
        item-text="nombre"
        item-value="id"
        placeholder="Seleccione"
        outlined
        dense
        clearable
        hide-details
        :menu-props="{ bottom: true, offsetY: true }"
      ></v-select>
    </div>

    <!-- Botones -->
    <v-btn
      class="text-none white--text mt-6"
      color="#22234A"
      rounded
      block
      @click="filtrar"
    >
      Filtrar
    </v-btn>
    <v-btn
      class="text-none mt-3"
      color="#22234A"
      outlined
      rounded
      block
      @click="limpiar"
    >
      Limpiar
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "AppFiltro",
  props: {
    nombreRuta: {
      type: String,
      default: "",
    },
    instituciones: {
      type: Array,
      default: () => [],
    },
    establecimientos: {
      type: Array,
      default: () => [],
    },
    areasInteres: {
      type: Array,
      default: () => [],
    },
    estadoPostulacion: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      menuFecha: false,
      menuPostulacion: false,
      fechasPublicacion: [],
      fechasPostulacion: [],
      localFiltro: {
        rangoFechasPublicacion: {
          fechaInicio: null,
          fechaFin: null,
        },
        rangoFechasPostulacion: {
          fechaInicio: null,
          fechaFin: null,
        },
        institucion: null,
        establecimiento: null,
        area_interes: null,
        estado_postulacion: null,
      },
    };
  },
  computed: {
    // Muestra el rango de fechas seleccionado con formato DD-MM-AAAA / DD-MM-AAAA
    fechaPublicacionFormatted() {
      if (!this.fechasPublicacion || this.fechasPublicacion.length === 0) {
        return "";
      }
      return this.fechasPublicacion
        .map((fecha) => this.formatFecha(fecha))
        .join(" / ");
    },
    fechaPostulacionFormatted() {
      if (!this.fechasPostulacion || this.fechasPostulacion.length === 0) {
        return "";
      }
      return this.fechasPostulacion
        .map((fecha) => this.formatFecha(fecha))
        .join(" / ");
    },
  },
  methods: {
    formatFecha(fecha) {
      if (!fecha) return "";
      const [anio, mes, dia] = fecha.split("-");
      return `${dia}-${mes}-${anio}`;
    },
    filtrar() {
      // Ordena el rango de fechas y lo asigna al filtro
      const [inicio, fin] = [...this.fechasPublicacion].sort();
      const [inicioPostulacion, finPostulacion] = [
        ...this.fechasPostulacion,
      ].sort();
      this.localFiltro.rangoFechasPublicacion = {
        fechaInicio: inicio || null,
        fechaFin: fin || null,
      };
      this.localFiltro.rangoFechasPostulacion = {
        fechaInicio: inicioPostulacion || null,
        fechaFin: finPostulacion || null,
      };
      this.$emit("actualizar-filtro", this.localFiltro);
    },
    limpiar() {
      this.fechasPublicacion = [];
      this.fechasPostulacion = [];
      this.localFiltro = {
        rangoFechasPublicacion: { fechaInicio: null, fechaFin: null },
        rangoFechasPostulacion: { fechaInicio: null, fechaFin: null },
        institucion: null,
        establecimiento: null,
        area_interes: null,
        estado_postulacion: null,
      };
      this.$emit("limpiar-filtro", this.localFiltro);
    },
  },
};
</script>

<style scoped>
.filtro-label {
  color: #1c1e4d;
  font-size: 14px;
  font-weight: 500;
}
</style>
